import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import './index.scss'

class FillViewHeight extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      top: 0,
      isSized: false,
    }
  }
  componentDidMount() {
    const rect = this.self.getBoundingClientRect()
    this.setState({
      top: rect.top,
      isSized: true,
    })
  }
  render() {
    const classNames = cn('fill-view-height-comp', { ready: this.state.isSized })
    return (
      <div
        className={classNames}
        style={{
          height: `calc(100vh - ${this.state.top}px)`,
        }}
        ref={(comp) => (this.self = comp)}
      >
        {this.props.children}
      </div>
    )
  }
}

FillViewHeight.propTypes = {
  children: PropTypes.node.isRequired,
}

export default FillViewHeight
